import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  const nodes: ReactNode[] = [];
  items.forEach((item, index) => {
    if (index > 0) {
      nodes.push(
        <i
          key={`sep-${item.label}`}
          className="ri-arrow-right-s-line text-foreground-400 text-base w-4 h-4 flex items-center justify-center"
        />,
      );
    }
    nodes.push(
      item.to ? (
        <Link
          key={item.label}
          to={item.to}
          className="text-sm text-foreground-500 hover:text-accent-600 transition-colors cursor-pointer"
        >
          {item.label}
        </Link>
      ) : (
        <span key={item.label} className="text-sm text-foreground-900 font-medium">
          {item.label}
        </span>
      ),
    );
  });

  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 mb-5">
      {nodes}
    </nav>
  );
}